module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/arrow_right_hov.svg?8da0021280d797b4dc7a9a9ae87bffb8";